export class CreateDto {
    product: string;
    campaign: string;
    description: string;
}
